/* ==========================================================================
   dex-master-verify-widget.js
   Self-contained in-page registry demo. Prototype source → vanilla JS.
   Reads container element for config. Auto-runs on scroll into view.
   ========================================================================== */

(function () {
  'use strict';

  // In-page demo registry (same records as prototype parts2.jsx)
  var REGISTRY = {
    'DEXR2025044': {
      status: 'active',
      holder: '',
      level: 'Dex Ready',
      code: 'DEX-R',
      domain: 'Healthcare',
      issued: '2025-04-15',
      renews: '2027-04-15',
      displayCode: 'DEXR-2025-04-A8K2'
    },
    'DEXA2024114': {
      status: 'active',
      holder: 'M. Okonkwo',
      level: 'Dex Associate',
      code: 'DEX-A',
      domain: 'Information Technology',
      issued: '2024-11-02',
      renews: '2026-11-02',
      displayCode: 'DEXA-2024-11-X3F7'
    },
    'DEXP2023074': {
      status: 'expired',
      holder: 'A. Singh',
      level: 'Dex Professional',
      code: 'DEX-P',
      domain: 'Marketing & Growth',
      issued: '2023-07-09',
      renews: '2025-07-09',
      displayCode: 'DEXP-2023-07-Q9R1'
    },
    'DEXM2024024': {
      status: 'revoked',
      holder: 'Withheld',
      level: 'Dex Management',
      code: 'DEX-M',
      domain: 'Construction',
      issued: '2024-02-21',
      renews: '2026-02-21',
      displayCode: 'DEXM-2024-02-B5T6'
    }
  };

  // Strip code to alphanumeric uppercase for lookup
  function stripCode(raw) {
    return (raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  // Normalise for display: uppercase, non-alnum → dash, group in 4s (max 19 chars)
  function normaliseCode(raw) {
    return (raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '').replace(/(.{4})(?=.)/g, '$1-').slice(0, 19);
  }

  // Load registry from Liquid-rendered JSON block when available; fall back to built-in object
  (function () {
    var el = document.getElementById('dmp-verify-data');
    if (!el) return;
    try {
      var parsed = JSON.parse(el.textContent || el.innerHTML);
      if (Array.isArray(parsed)) {
        REGISTRY = {};
        parsed.forEach(function (r) { if (r && r.key) REGISTRY[r.key] = r; });
      }
    } catch (e) {}
  })();

  // Build a stripped-key lookup table (after any registry override)
  var REGISTRY_STRIPPED = {};
  Object.keys(REGISTRY).forEach(function (k) {
    var stripped = stripCode(REGISTRY[k].displayCode);
    REGISTRY_STRIPPED[stripped] = REGISTRY[k];
  });

  // SVG helpers
  var SVG_CHECK  = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 7 9 18l-5-5"/></svg>';
  var SVG_SEARCH = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>';
  var SVG_LOCK   = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';

  function init(container) {
    var urlDisplay  = container.dataset.urlDisplay  || 'registry.askfordex.ca / verify';
    var placeholder = container.dataset.placeholder || 'DEXA-2024-11-X3F7';
    var tipText     = container.dataset.tipText     || 'Tip · pick a sample code above, or type your own.';

    // Sample codes to show as chips
    var sampleCodes = [
      { display: 'DEXR-2025-04-A8K2', stripped: 'DEXR2025044' },
      { display: 'DEXA-2024-11-X3F7', stripped: 'DEXA2024114' },
      { display: 'DEXP-2023-07-Q9R1', stripped: 'DEXP2023074' },
      { display: 'DEXM-2024-02-B5T6', stripped: 'DEXM2024024' }
    ];

    // Build DOM
    container.innerHTML =
      '<div class="v-widget-inner">' +
        '<div class="v-copy dmp-fade-in">' +
          (container.dataset.eyebrow ? '<p class="eyebrow">' + esc(container.dataset.eyebrow) + '</p>' : '') +
          (container.dataset.heading ? '<h2 class="h-section" style="margin-top:12px">' + esc(container.dataset.heading) + '</h2>' : '') +
          (container.dataset.body1   ? '<p class="h-sub" style="margin-top:16px">' + esc(container.dataset.body1) + '</p>' : '') +
          (container.dataset.body2   ? '<p class="t-body" style="margin-top:16px">' + esc(container.dataset.body2) + '</p>' : '') +
          '<div class="v-codes" role="list" aria-label="Sample codes to try">' +
            sampleCodes.map(function (s) {
              return '<button class="v-code-chip" data-code="' + s.display + '" role="listitem"><span class="label">Try</span><span>' + esc(s.display) + '</span></button>';
            }).join('') +
            '<button class="v-code-chip" data-code="XXXX-XXXX-XXXX-XXXX" role="listitem"><span class="label">Try</span><span>not-found</span></button>' +
          '</div>' +
        '</div>' +
        '<div class="v-browser dmp-fade-in" role="region" aria-label="Public registry · live verification">' +
          '<div class="v-browser-chrome">' +
            '<div class="v-dots"><span></span><span></span><span></span></div>' +
            '<div class="v-url">' + SVG_LOCK + ' ' + esc(urlDisplay) + '</div>' +
          '</div>' +
          '<div class="v-body">' +
            '<form class="v-search" role="search">' +
              '<label class="sr-only" for="dmp-v-input" style="position:absolute;left:-9999px">Verification code</label>' +
              '<input id="dmp-v-input" class="v-input" type="text" placeholder="' + esc(placeholder) + '" inputmode="text" autocomplete="off" spellcheck="false" aria-describedby="dmp-v-hint" />' +
              '<button type="submit" class="v-btn" aria-label="Verify code">' + SVG_SEARCH + ' Verify</button>' +
            '</form>' +
            '<div id="dmp-v-hint" class="v-hint">' + esc(tipText) + '</div>' +
            '<div class="v-result-area"><div class="v-empty" aria-live="polite">No code checked yet. Pick a sample or type a code above.</div></div>' +
          '</div>' +
        '</div>' +
      '</div>';

    // Reveal dynamically-built elements — product.js observer won't see them
    var fadeEls = container.querySelectorAll('.dmp-fade-in');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fadeEls.forEach(function (el) { el.classList.add('visible'); });
      });
    });

    var input       = container.querySelector('#dmp-v-input');
    var form        = container.querySelector('.v-search');
    var resultArea  = container.querySelector('.v-result-area');
    var verifyBtn   = container.querySelector('.v-btn');
    var chips       = container.querySelectorAll('.v-code-chip');

    // Chip clicks
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { lookup(chip.dataset.code); });
    });

    // Input normalise on type
    input.addEventListener('input', function () {
      var pos = input.selectionStart;
      var raw = input.value;
      var norm = normaliseCode(raw);
      if (norm !== raw) {
        input.value = norm;
        try { input.setSelectionRange(pos, pos); } catch (e) {}
      }
    });

    // Form submit
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (input.value.trim()) lookup(input.value);
    });

    function lookup(codeRaw) {
      var display = normaliseCode(codeRaw);
      var stripped = stripCode(codeRaw);
      input.value = display;

      // Loading state
      verifyBtn.disabled = true;
      verifyBtn.innerHTML = '<span class="v-spin"></span> Verifying';
      resultArea.innerHTML = '<div class="v-empty" aria-live="polite">Checking the registry…</div>';

      setTimeout(function () {
        verifyBtn.disabled = false;
        verifyBtn.innerHTML = SVG_SEARCH + ' Verify';

        var rec = REGISTRY_STRIPPED[stripped];
        if (rec) {
          resultArea.innerHTML = buildResult(rec);
        } else {
          resultArea.innerHTML = buildNotFound(display || stripped);
        }
      }, 700);
    }

    function buildResult(r) {
      if (r.status === 'revoked') {
        return '<div class="v-result is-revoked" role="status" aria-live="polite">' +
          '<div class="v-result-head">' +
            '<div><div class="v-result-l">Result</div><div class="v-result-h" style="color:#92400E">Record revoked</div></div>' +
            '<span class="v-result-status v-status-revoked"><span class="v-dot"></span>Revoked</span>' +
          '</div>' +
          '<p style="margin:0;font-size:14px;color:#78350F">This record was withdrawn from the public registry. The holder cannot rely on it as a current credential.</p>' +
        '</div>';
      }
      var statusCls   = r.status === 'active' ? 'v-status-active' : 'v-status-expired';
      var statusLabel = r.status === 'active' ? 'Active' : 'Expired';
      return '<div class="v-result" role="status" aria-live="polite">' +
        '<div class="v-result-head">' +
          '<div><div class="v-result-l">Credential found</div><div class="v-result-h">' + esc(r.level) + '</div></div>' +
          '<span class="v-result-status ' + statusCls + '"><span class="v-dot"></span>' + statusLabel + '</span>' +
        '</div>' +
        '<div class="v-result-grid">' +
          (r.holder ? '<div><div class="v-field-l">Holder</div><div class="v-field-v">' + esc(r.holder) + '</div></div>' : '') +
          '<div><div class="v-field-l">Field</div><div class="v-field-v">' + esc(r.domain) + '</div></div>' +
          '<div><div class="v-field-l">Level</div><div class="v-field-v">' + esc(r.code) + '</div></div>' +
          '<div><div class="v-field-l">Status</div><div class="v-field-v">' + statusLabel + '</div></div>' +
          '<div><div class="v-field-l">Issued</div><div class="v-field-v mono">' + esc(r.issued) + '</div></div>' +
          '<div><div class="v-field-l">Renews</div><div class="v-field-v mono">' + esc(r.renews) + '</div></div>' +
          '<div style="grid-column:1/-1;padding-top:12px;margin-top:4px;border-top:1px solid #E2E8F0"><div class="v-field-l">Code</div><div class="v-field-v mono">' + esc(r.displayCode) + '</div></div>' +
        '</div>' +
      '</div>';
    }

    function buildNotFound(code) {
      return '<div class="v-result is-not-found" role="status" aria-live="polite">' +
        '<div class="v-result-head">' +
          '<div><div class="v-result-l">Result</div><div class="v-result-h" style="color:#991B1B">No record found</div></div>' +
          '<span class="v-result-status v-status-notfound"><span class="v-dot" style="background:#991B1B"></span>Not found</span>' +
        '</div>' +
        '<p style="margin:0;font-size:14px;color:#7F1D1D">The code <strong style="font-variant-numeric:tabular-nums">' + esc(code) + '</strong> is not in the Dex registry. Check the spelling, or ask the person for a current code.</p>' +
      '</div>';
    }

    // Auto-run on first scroll into view
    var fired = false;
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !fired) {
            fired = true;
            setTimeout(function () { lookup('DEXA-2024-11-X3F7'); }, 600);
          }
        });
      }, { threshold: 0.35 });
      obs.observe(container);
    }
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Boot when DOM ready
  function boot() {
    var containers = document.querySelectorAll('[data-dmp-verify]');
    containers.forEach(function (c) { init(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
